import { useIsAuthenticated } from "@zapier/payment/esm/hooks/useIsAuthenticated";
import { ApolloInjection } from "@zapier/payment/esm/types";
import { isBrowser } from "@zapier/payment/esm/utils/isBrowser";

type UserCurrentAccountResult = {
  accountId: number | undefined;
  error: string | undefined;
  isLoading: boolean;
};

type Props = {
  skip?: boolean;
  useQuery?: ApolloInjection["useQuery"];
};

export const useCurrentAccountId = (
  props: Props = {}
): UserCurrentAccountResult => {
  const { isAuthenticated, error, isLoading } = useIsAuthenticated(props);

  const response = {
    accountId: undefined,
    error: error ? "Error loading current account ID." : undefined,
    isLoading,
  };

  if (!isAuthenticated || !isBrowser()) {
    return response;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem("currentAccountId");

  return {
    ...response,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
